<template>
  <el-dialog
    :title="mfrInfo.mfname ? $t('langcfg.txtEdit') : $t('langcfg.txtAdd')"
    :visible.sync="showDialog"
    width="600px"
    append-to-body
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="200px" label-position="top">
      <el-form-item
        :label="$t('langcfg.txtManufacturer')"
        prop="mfname"
        style="margin-bottom: 10px"
      >
        <el-input
          v-model="form.mfname"
          @click.native.stop.prevent="handleClick('mfname')"
          @touchend.native.stop.prevent="handleClick('mfname')"
        />
      </el-form-item>
      <el-form-item :label="$t('langcfg.txtPhone')" prop="phone">
        <el-input
          v-model="form.phone"
          @click.native.stop.prevent="handleClick('phone')"
          @touchend.native.stop.prevent="handleClick('phone')"
        />
      </el-form-item>
      <el-form-item :label="$t('langcfg.txtAddress')" prop="address">
        <el-input
          v-model="form.address"
          @click.native.stop.prevent="handleClick('address')"
          @touchend.native.stop.prevent="handleClick('address')"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="save">{{ $t("langcfg.txtSave") }}</el-button>
      <el-button @click="cancel">{{ $t("langcfg.txtCancel") }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import EVENTS from "../../bus";
export default {
  name: "RGP-MfrEdit",
  components: {},
  props: {
    mfrInfo: {
      type: Object,
      default: () => {
        return {
          mfname: "",
          phone: "",
          address: ""
        };
      }
    },
    show: Boolean
  },
  data() {
    return {
      form: {
        mfname: "",
        phone: "",
        address: ""
      },
      rules: {
        mfname: [{ required: true, message: this.$t("langcfg.txtNameNotEmpty"), trigger: "blur" }]
      }
    };
  },
  created() {
    // console.log(this.mfrInfo)
  },
  mounted() {},
  methods: {
    handleClick(key) {
      let self = this;

      this.$bus.$emit(EVENTS.spreadKeyBoard, self.form[key], (value) => {
        self.form[key] = value;
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit("save", this.form);
        } else {
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    }
  },
  watch: {
    mfrInfo(newVal) {
      this.form = JSON.parse(JSON.stringify(newVal));
    }
  },
  computed: {
    showDialog: {
      get: function () {
        return this.show;
      },
      set: function (val) {
        this.$emit("update:show", val);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.el-button {
  margin-left: 5%;
  font-size: @header-fs;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/RGP-MfrEdit.vue